import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

export default function TermsPage() {
  return (
    <div className="min-h-screen flex flex-col" style={{ background: "linear-gradient(160deg, #f0fdf4 0%, #f8fafc 50%, #ecfdf5 100%)" }}>
      <Navbar />
      <div className="h-1 bg-gradient-to-r from-emerald-400 via-teal-400 to-emerald-500" />

      <main className="flex-1 pt-24 pb-20">
        <div className="max-w-3xl mx-auto px-4 md:px-6">
          {/* Back */}
          <Link
            to="/"
            className="inline-flex items-center gap-1.5 text-sm text-slate-500 hover:text-emerald-600 transition-colors cursor-pointer mb-6"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-left-line" />
            </div>
            Back to Home
          </Link>

          <div className="bg-white rounded-2xl border border-emerald-100 overflow-hidden">
            {/* Header */}
            <div className="px-8 py-8 border-b border-gray-100" style={{ background: "linear-gradient(135deg, #f0fdf4 0%, #ecfdf5 100%)" }}>
              <div className="flex items-center gap-3 mb-2">
                <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-emerald-100 text-emerald-600">
                  <i className="ri-file-text-line text-xl" />
                </div>
                <h1 className="text-2xl font-bold text-slate-800">Terms of Service</h1>
              </div>
              <p className="text-slate-500 text-sm">Last updated: April 2026</p>
            </div>

            {/* Content */}
            <div className="px-8 py-8 space-y-8 text-slate-600 text-sm leading-relaxed">
              <section>
                <h2 className="text-base font-semibold text-slate-800 mb-3">1. Acceptance of Terms</h2>
                <p>
                  By accessing and using the Sonic Express Services parcel tracking platform, you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our service. We reserve the right to update these terms at any time, and continued use of the service constitutes acceptance of any changes.
                </p>
              </section>

              <section>
                <h2 className="text-base font-semibold text-slate-800 mb-3">2. Use of the Service</h2>
                <p className="mb-2">You agree to use this service only for lawful purposes. You must not:</p>
                <ul className="list-disc list-inside space-y-1 text-slate-500 pl-2">
                  <li>Attempt to gain unauthorized access to any part of the platform</li>
                  <li>Use automated tools to scrape or bulk-query tracking data</li>
                  <li>Misrepresent your identity or affiliation with any shipment</li>
                  <li>Interfere with the normal operation of the tracking system</li>
                </ul>
              </section>

              <section>
                <h2 className="text-base font-semibold text-slate-800 mb-3">3. Tracking Information Accuracy</h2>
                <p>
                  Sonic Express Services provides tracking information in good faith based on data entered by authorized administrators. While we strive for accuracy, we cannot guarantee that all tracking information is error-free or up to date at all times. Estimated delivery dates are indicative only and may change due to circumstances beyond our control.
                </p>
              </section>

              <section>
                <h2 className="text-base font-semibold text-slate-800 mb-3">4. Limitation of Liability</h2>
                <p>
                  Sonic Express Services shall not be liable for any direct, indirect, incidental, or consequential damages arising from the use or inability to use this tracking platform. This includes but is not limited to delays, inaccuracies in tracking data, or loss of parcel contents. Liability for physical shipments is governed by the terms agreed upon at the time of shipment.
                </p>
              </section>

              <section>
                <h2 className="text-base font-semibold text-slate-800 mb-3">5. Intellectual Property</h2>
                <p>
                  All content on this platform, including the design, logo, text, and functionality, is the property of Sonic Express Services and is protected by applicable intellectual property laws. You may not reproduce, distribute, or create derivative works without our express written permission.
                </p>
              </section>

              <section>
                <h2 className="text-base font-semibold text-slate-800 mb-3">6. Termination</h2>
                <p>
                  We reserve the right to restrict or terminate access to our platform at any time, without notice, for conduct that we believe violates these Terms of Service or is harmful to other users, us, or third parties.
                </p>
              </section>

              <section>
                <h2 className="text-base font-semibold text-slate-800 mb-3">7. Governing Law</h2>
                <p>
                  These Terms of Service shall be governed by and construed in accordance with applicable laws. Any disputes arising from the use of this service shall be resolved through good-faith negotiation, and if necessary, through appropriate legal channels.
                </p>
              </section>

              <section>
                <h2 className="text-base font-semibold text-slate-800 mb-3">8. Contact</h2>
                <p>
                  For questions regarding these Terms of Service, please reach out to us at:{" "}
                  <a href="mailto:sonicexpresservices@gmail.com" className="text-emerald-600 hover:underline font-medium">
                    sonicexpresservices@gmail.com
                  </a>
                </p>
              </section>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
